module.exports = "/_next/static/images/31881ca788e3db432335d9b364348cde-sanpablo-4.jpg";